import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackageCkeck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPackageCkeck"><Path d="M3 21V3H8V10H16V3H21V12.818L17 16.818L15.25 15.068L12.068 18.25L14.818 21H3Z" fill="currentColor"/><Path d="M14.5 3H9.5V8.5H14.5V3Z" fill="currentColor"/><Path d="M17 21.0607L22.0607 16L21 14.9393L17 18.9393L15.25 17.1893L14.1893 18.25L17 21.0607Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPackageCkeck;
